// extracted by mini-css-extract-plugin
module.exports = {"container":"SeksjonForKontaktinformasjonPart_container__8z864","header":"SeksjonForKontaktinformasjonPart_header__bEO6A","links":"SeksjonForKontaktinformasjonPart_links___pm2g"};